(function (angular) {
    angular
        .module('harriApp')
        .controller('applyWarningModal', [
            '$scope', '$state', 'modalData', 'onSave', 'onClose',
            function ($scope, $state, modalData, onSave, onClose) {

                $scope.modalData = modalData;
                $scope.saving = false;

                $scope.tryAgain = function () {
                    $scope.$hide();
                    onSave();
                };

                $scope.discard = function () {
                    $scope.$hide();
                    onClose();
                };

                //Hide modal
                $scope.close = function () {
                    $scope.$hide();
                };
            }]);
})(angular);
